import { AppRecordValidateResult } from '@xbcb/ui-types';
import { VneFieldValidator, VneValidationArgs } from '../types';
import { VneRequirements } from 'libs/pgaHelpers/epa';

export class ExemptionNumberValidator implements VneFieldValidator {
  isApplicable(args: VneValidationArgs): boolean {
    const { vneImportCode } = args.pga;
    if (vneImportCode) {
      return VneRequirements.isExemptionNumberRequired(vneImportCode);
    }
    return false;
  }

  validate(_: VneValidationArgs): AppRecordValidateResult {
    return {
      validateFields: [['vneExemptionNumber']],
    };
  }
}
